/*
 *   File : add-admin.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CustomSelectMenu, Input } from "../../Components/FormElements";
import { PrimaryButton } from "../../Components/Cta";
import { APIService } from "../../Service";
import { toast } from "react-toastify";

export default function AddModules() {
  const navigate = useNavigate();
  const { id } = useParams();

  // States
  const [name, setName] = useState("");
  const [role, setRole] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const [nameError, setNameError] = useState("");
  const [roleError, setRoleError] = useState("");

  // Load data for edit
  useEffect(() => {
    _getFilterData();
  }, []);

  useEffect(() => {
    const stored = JSON.parse(sessionStorage.getItem("editingSubAdmin"));
    if (stored) {
      setName(stored.name);
      setRole(formatModules(stored.modules));
    }
  }, [id]);

  // Validation functions
  const _validateName = () => {
    if (!name?.trim()) {
      setNameError("Name is required");
      return false;
    }
    setNameError("");
    return true;
  };

  const formatModules = (modules = []) =>
    modules.map((mod) => ({
      value: mod.module_id,
      label: mod.name,
    }));

  const _validateRole = () => {
    if (role.length === 0) {
      setRoleError("Role is Required");
      return false;
    }
    setRoleError("");
    return true;
  };

  const _handleSave = () => {
    const isNameValid = _validateName();
    const isRoleValid = _validateRole();

    if (isNameValid && isRoleValid) {
      _upsert_role();
    }
  };

  //service to upsert role
  const _upsert_role = () => {
    const is_post = true;
    const payload = {
      role_id: id ? id : null,
      name: name,
      modules: role.map((e) => e.value),
    };
    const url = id ? "sub-admin/roles/edit" : "sub-admin/roles/add";
    APIService(is_post, url, payload)
      .then((response) => {
        if (response.status_code === 200) {
          navigate("/manage-sub-admin/modules");
          toast.success(response.message);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  //service to get filter data
  const _getFilterData = () => {
    const is_post = false;
    APIService(is_post, "sub-admin/modules-data")
      .then((response) => {
        if (response.status_code === 200) {
          setFilterData(response.data);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <div className="row px-3 e-pt-20px">
      <div className="col-lg-7">
        <div className=" e-bg-ghost-white-dark  e-border-radius-16 p-3 e-border-1px-pale-lavender w-100">
          <h5 className="e-font-16 e-primary-font-poppins e-font-weight-600 e-text-eerie-black line-height-24px pb-1">
            {id ? "Edit Role" : "Create new role"}
          </h5>
          <div className="row">
            <div className=" col-lg-10 col-12">
              <div className="d-flex flex-column row-gap-3">
                <div className="row">
                  <Input
                    id="name"
                    type="text"
                    label="Name"
                    placeholder="Enter name"
                    require={true}
                    value={name}
                    error={nameError}
                    className="e-primary-font-poppins w-100"
                    onKeyPress={(e) => e.key === "Enter" && _validateName()}
                    handleChange={(e) => setName(e)}
                    autoFocus={!id}
                  />
                </div>

                {/* Description Permissions */}
                <div className="row">
                  <label className="e-font-14 e-font-weight-500 text-capitalize e-primary-font-poppins mb-2">
                    Modules <span className="text-danger">*</span>
                  </label>
                  <CustomSelectMenu
                    options={filterData}
                    placeholder="Select Module"
                    value={role}
                    isMulti={true}
                    onChange={(selected) => setRole(selected)}
                    type={2}
                  />
                  {roleError && (
                    <span className="text-danger e-primary-font-poppins e-font-12 mt-1">
                      {roleError}
                    </span>
                  )}
                </div>

                {/* Button Group */}
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-6">
                        <PrimaryButton
                          ClassName="e-border-radius-pill e-border-1px-blue e-font-weight-500 e-font-16 w-100 bg-transparent e-text-blue-violet e-primary-font-poppins"
                          name="Cancel"
                          onPress={() => navigate("/manage-sub-admin")}
                        />
                      </div>
                      <div className="col-6">
                        <PrimaryButton
                          ClassName="e-border-radius-pill e-font-weight-500 e-font-16 w-100 e-bg-blue-violet text-white e-primary-font-poppins"
                          name={id ? "Update Role" : "Create Role"}
                          onPress={_handleSave}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
